import React from 'react';
import { Checkbox, Radio } from 'freemium-ui';
import { MatrixTypes, SurveyQuestionType } from 'freemium-survey-components';
import { get } from 'lodash';
import { SurveyResponseDetailedDataType } from 'shared/types';
import { MatrixCheckBox, StyledMatrix } from './styles';

type MatrixQuestionProps = {
  question: SurveyQuestionType;
  respondedQuestionAnswer?: SurveyResponseDetailedDataType | null;
  brandColor: string;
};

export const MatrixQuestion = ({
  question,
  respondedQuestionAnswer,
  brandColor,
}: MatrixQuestionProps) => {
  const matrixType = get(question, 'type_info.matrix_properties.type') as
    | MatrixTypes
    | undefined;
  const labels = respondedQuestionAnswer?.labels || [];
  const statements: {
    rating_labels: string[];
    statement_text: string;
    order: number;
  }[] = respondedQuestionAnswer?.answer.sort((a, b) => a.order - b.order) || [];

  return (
    <StyledMatrix>
      <table className="st-mt-table">
        <thead className="st-mt-thead">
          <tr className="st-mt-tr">
            <th className="m-s-b-s-q-m-s-th-empty st-mt-th" />
            {labels?.map((rl) => {
              return (
                <th key={rl} className="m-s-b-s-q-m-s-th st-mt-th">
                  {rl}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="st-mt-tbody">
          {statements?.map?.((s) => {
            return (
              <tr
                key={s.statement_text}
                className="m-s-b-s-q-m-s-tr-hover st-mt-tr"
              >
                <td className="m-s-b-s-q-m-s-input st-mt-td">
                  {s.statement_text || ''}
                </td>
                {labels?.map((rl) => {
                  return (
                    <td key={rl} className="m-s-b-s-q-m-s-switch st-mt-td">
                      {matrixType === 'SINGLE_ANSWER' && (
                        <Radio
                          name="q-m-s-radio"
                          checked={s.rating_labels.includes(rl)}
                          disabled
                          readOnly
                        />
                      )}
                      {matrixType === 'MULTIPLE_ANSWERS' && (
                        <MatrixCheckBox
                          brandColor={
                            s.rating_labels.includes(rl)
                              ? brandColor
                              : 'transparent'
                          }
                        >
                          <Checkbox
                            name="q-m-s-checkbox"
                            checked={s.rating_labels.includes(rl)}
                            readOnly
                          />
                        </MatrixCheckBox>
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledMatrix>
  );
};
